import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, todayISO } from "@/lib/api";
import { toast } from "sonner";

export default function ReceiveWorkDialog({ work, onOpenChange, onSuccess }) {
  const [qty, setQty] = useState("");
  const [date, setDate] = useState(todayISO());
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const remaining = work ? (work.quantity_given - work.quantity_received) : 0;

  useEffect(() => {
    if (work) {
      setQty(String(remaining));
      setDate(todayISO());
      setNotes("");
    }
  }, [work, remaining]);

  const submit = async (e) => {
    e.preventDefault();
    const q = parseInt(qty, 10);
    if (!q || q < 1) {
      toast.error("Geçerli bir adet girin");
      return;
    }
    setSaving(true);
    try {
      await api.post(`/works/${work.id}/receive`, {
        quantity_received: q,
        received_date: date,
        notes,
      });
      toast.success("Teslim alındı");
      onOpenChange(false);
      onSuccess?.();
    } catch {
      toast.error("İşlem başarısız");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!work} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl sm:max-w-md" data-testid="receive-work-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Teslim Al</DialogTitle>
        </DialogHeader>
        {work && (
          <form onSubmit={submit} className="space-y-4">
            <div className="rounded-xl bg-[#F9F9F8] border border-[#E6E6E2] p-4">
              <div className="text-sm font-medium text-[#1A1D1A]">{work.worker_name} · {work.work_type}</div>
              <div className="text-xs text-[#5C605C] mt-1">Kalan: <span className="font-semibold text-[#A85F26]">{remaining}</span> adet</div>
            </div>

            <div>
              <label className="text-xs font-semibold tracking-widest uppercase text-[#5C605C]">Alınan Adet</label>
              <Input
                type="number"
                min="1"
                max={remaining}
                value={qty}
                onChange={(e) => setQty(e.target.value)}
                className="mt-1.5 h-12 rounded-xl border-[#E6E6E2] focus-visible:ring-[#3B5249]/25"
                data-testid="receive-qty-input"
              />
            </div>

            <div>
              <label className="text-xs font-semibold tracking-widest uppercase text-[#5C605C]">Teslim Alma Tarihi</label>
              <Input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                className="mt-1.5 h-12 rounded-xl border-[#E6E6E2] focus-visible:ring-[#3B5249]/25"
                data-testid="receive-date-input"
              />
            </div>

            <div>
              <label className="text-xs font-semibold tracking-widest uppercase text-[#5C605C]">Not (opsiyonel)</label>
              <Textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                rows={2}
                className="mt-1.5 rounded-xl border-[#E6E6E2] focus-visible:ring-[#3B5249]/25"
                data-testid="receive-notes-input"
              />
            </div>

            <DialogFooter>
              <Button type="button" variant="ghost" onClick={() => onOpenChange(false)} className="rounded-full h-11 px-5 transition-colors" data-testid="receive-cancel">
                İptal
              </Button>
              <Button type="submit" disabled={saving} className="rounded-full h-11 px-6 bg-[#5C7D64] hover:bg-[#4A6752] text-white transition-colors" data-testid="receive-submit">
                {saving ? "Kaydediliyor..." : "Teslim Al"}
              </Button>
            </DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
